import { toast } from 'react-toastify';

const handleQueryError = async (error, key) => {
  let errorMessage = error?.message;

  const isNetworkError = errorMessage === 'Network Error';

  const toastErrorId = key.replace(/ /g, '-').toLowerCase();

  if (errorMessage) {
    toast.error(errorMessage, {
      toastId: isNetworkError ? 'network-error' : toastErrorId
    });
  }
};

export { handleQueryError };
